<template>
    <div class="news-page"
        :style="{ '--themeColor': themeColor, paddingTop: styleTemp.topStyle && styleTemp.topStyle.slideEffect === 'suspension' ? '100px' : '' }"
        v-loading="isLoading">
        <div class="news-page-body">
            <div class="body-left">
                <div class="body-left-title">
                    <span>{{ navTitle }}</span>
                    <span style="margin: 0 5px;">></span>
                    <span>{{ dataInfo.name }}</span>
                </div>
                <div>
                    <OaExamineAudit ref="AuditOpenChild" class="oaExamineAudit" :open="true" :websiteSwitch="websiteSwitch" />
                </div>
            </div>
            <div class="body-right" style="padding-right: 0;">
                <div class="body-right-title">
                    {{ dataInfo.name }}
                </div>
                <el-scrollbar style="padding-right: 20px;">
                    <ul class="body-right-list">
                        <li class="list-item" @click="goDetail(item)" v-for="(item, idx) in list" :key="idx"
                            :class="Number(curApprovingId) === item.approvingId ? 'l-list-active' : ''">
                            <span class="title">{{ getContent(item, 'appenField') }}</span>
                            <span class="time">{{ formatDate(getContent(item, 'appenTime')) }}</span>
                        </li>
                    </ul>
                </el-scrollbar>
                <div class="body-right-foot" style="padding-right: 20px;" v-if="total > 10">
                    <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                        :current-page="page" :page-size="10" :total="total" style="padding: 0;">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { openapiGetcustomdata, outGetcustomdata } from '@/port/schoolInstrument/appConfig'
import { cloneDeep } from 'lodash'
import { getcustomdataconf } from '@/port/pages/webSite'
import { dealFixQuery } from '../mutual/common/config'
import OaExamineAudit from '@/components/clientSide/oaExamineAudit.vue'
import { formatDate } from '@/api/global.js'
export default {
    // 组件名称
    name: 'newsPage',
    // 组件参数 接收来自父组件的数据
    props: {
        config: {
            type: Object,
            default: () => ({})
        },
        themeColor: {
            type: String,
            default: '#4e86ff'
        },
        websiteSwitch: {
            type: Boolean,
            default: false
        },
        styleTemp: {
            type: Object,
            default: () => {
                return {
                    topStyle: {
                        slideEffect: ''
                    }
                }
            }
        }
    },
    // 局部注册的组件
    components: {
        OaExamineAudit
    },
    // 组件状态值
    data() {
        return {
            dataInfo: {},
            list: [],
            allList: [],
            page: 1,
            total: 20,
            navTitle: '',
            skey: '',
            spaceid: this.$route.query.spaceid,
            upaceid: this.$route.query.upaceid,
            isLoading: true,
            curApprovingId: '',
        }
    },
    mounted() {
        this.init()
    },
    // 计算属性
    computed: {},
    // 侦听器
    watch: {},
    // 组件方法
    methods: {
        formatDate(time) {
            //时间戳转成时间
            let date = new Date(time)
            return formatDate(date, 'yyyy-MM-dd') //yyyy-MM-dd hh:mm
        },
        async init() {
            const { l: approvingId, id } = this.$route.query
            this.skey = this.$route.params.skey || this.$route.query.skey || ''
            if (id) {
                const f = await getcustomdataconf({ key: id }).catch(() => {
                    this.$message.error('获取数据失败')
                    this.isLoading = false
                })
                if (f.code === 0 && f.data) {
                    const data = JSON.parse(f.data)
                    const { info, title } = data
                    this.dataInfo = JSON.parse(info)
                    this.navTitle = title
                    this.curApprovingId = approvingId
                    this.getList()
                } else {
                    this.isLoading = false
                }
            }
        },
        getContent(item, type = 'appenField', list) {
            let formdata = item.approving.formdata
            let value = null
            if (list) {
                value = list[type]
            } else {
                value = this.dataInfo[type]
            }
            formdata = JSON.parse(formdata)
            const defaultVal = type === 'appenField' ? item.appname || item.name : item.ctime
            if (value && Object.keys(value).length !== 0) {
                const title = value.title
                const type = value.type
                if (title === '数据标题' || title === '提交时间') {
                    return defaultVal
                } else {
                    const data = formdata[`${title}_${type}`]
                    return this.getValue(data)
                }
            } else {
                return defaultVal
            }
        },
        getValue(val) {
            const flag = Array.isArray(val)
            if (flag) {
                const f = val[0]
                const e = val
                if (f && f.userId) {
                    // 如果有userId说明是联系人控件
                    var ej = []
                    e.forEach((i) => {
                        ej.push(i.realname)
                    })
                    return ej.join(',')
                } else if (f && (f.organizationId || f.roleId)) {
                    const ej = []
                    e.forEach(i => {
                        ej.push(i.name)
                    })
                    return ej.join(',')
                } else {
                    return e.join(',')
                }
            } else {
                return val
            }
        },
        async goDetail(item) {
            const query = cloneDeep(this.$route.query)
            query.l = item.approvingId
            this.$router.push({
                path: this.$route.path,
                query
            })
            await this.$nextTick()
            this.$refs.AuditOpenChild.AuditOpenList(item, 1)
            this.curApprovingId = item.approvingId
        },
        processPaging(curpage = 1, pagesize = 10) {
            const prev = (curpage - 1) * pagesize
            const next = curpage * pagesize
            const list = cloneDeep(this.allList)
            return list.splice(prev, next)
        },
        handleCurrentChange(val) {
            this.page = val
            this.list = this.processPaging(val, 10)
        },
        async getList() {
            this.isLoading = true
            const curl = cloneDeep(this.dataInfo)
            const rulerData = curl.rulerData || {}
            let obj = {
                pagesize: 0,
            }
            if (this.isSearch) obj.key = this.search
            if (rulerData) {
                rulerData.fixquery = dealFixQuery(rulerData.fixquery || {})
            }
            obj = {
                ...obj,
                ...rulerData
            }
            if (this.spaceid) {
                obj.spaceid = this.spaceid
            } else if (this.upaceid) {
                obj.upaceid = this.upaceid
            }
            obj.curpage = this.page
            obj.appid = curl.appid
            // 官网走这边
            let fn = openapiGetcustomdata
            if (this.skey) {
                fn = outGetcustomdata
                obj = {
                    ...obj,
                    skey: this.skey,
                    inquire: 4,
                }
                if (obj.fixquery) {
                    obj.fixquery = JSON.stringify(obj.fixquery)
                }
                if (obj.fixorder) {
                    obj.fixorder = JSON.stringify(obj.fixorder)
                }
            } else {
                obj = {
                    ...obj,
                    inquire: curl.inquire,
                }
            }
            const res = await fn(obj).catch(() => {
                this.isLoading = false
            })
            this.isLoading = false
            if (res.code === 0) {
                this.total = res.total
                this.allList = res.data
                const idx = res.data.findIndex(c => c.approvingId === Number(this.curApprovingId))
                let info = null
                if (idx !== -1 && idx > 10) {
                    info = this.allList[idx]
                    const num = Number(idx.toString()[0]) + 1
                    this.page = num
                    this.list = this.processPaging(num, 10)
                } else if (idx !== 1) {
                    info = this.allList[idx]
                    this.list = this.processPaging(1, 10)
                } else {
                    info = this.allList[idx]
                    this.list = this.processPaging(1, 10)
                }
                await this.$nextTick()
                if (this.$refs.AuditOpenChild) {
                    this.$refs.AuditOpenChild.AuditOpenList(info, 1)
                }
            }
        },
    },
}
</script>

<style scoped lang="scss">
.news-page {
    $themeColor: var(--themeColor);
    width: 100%;
    height: 100%;
    padding-top: 40px;
    box-sizing: border-box;

    &-body {
        width: 1440px;
        box-sizing: border-box;
        height: fit-content;
        margin: 0 auto;
        display: flex;

        .body-left {
            flex: 1;
            background-color: #fff;
            padding: 0 23px;
            box-sizing: border-box;
            overflow: auto;

            &-title {
                height: 52px;
                border-bottom: solid 1px #eaecf0;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                color: #999999;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
            }

            ::v-deep .oaExamineAudit {
                .cur-detail {
                    .el-scrollbar {
                        height: inherit !important;

                        .el-scrollbar__wrap {
                            height: inherit;

                            .el-scrollbar__view {
                                height: inherit;
                            }
                        }

                        .is-vertical {
                            display: none;
                        }
                    }
                }
            }
        }
        .body-right {
            width: 425px;
            margin-left: 35px;
            height: fit-content;
            background-color: #fff;
            padding: 24px 20px;
            box-sizing: border-box;

            &-title {
                height: 28px;
                width: 100%;
                position: relative;
                padding-left: 22px;
                line-height: 28px;
                color: #333333;
                font-weight: 500;
                font-size: 20px;
                margin-bottom: 9px;

                &::after {
                    width: 6px;
                    height: 100%;
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    background-color: $themeColor;
                }
            }

            &-list {
                .l-list-active {
                    .time {
                        color: $themeColor !important;
                    }

                    .title {
                        color: $themeColor;
                    }
                }

                .list-item {
                    display: flex;
                    justify-content: center;
                    padding: 15px 0;
                    border-bottom: solid 1px #eaecf0;
                    cursor: pointer;
                    color: #333333;
                    font-weight: 400;
                    font-size: 14px;

                    &:last-of-type {
                        border-bottom: none;
                    }

                    &:hover {
                        .time {
                            color: $themeColor;
                        }

                        .title {
                            color: $themeColor;
                        }
                    }

                    .time {
                        width: 90px;
                        text-align: right;
                        color: #999999;
                    }

                    .title {
                        width: calc(100% - 10px);
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }

            &-foot {
                margin-top: 17px;
                width: 100%;
                text-align: right;
            }
        }
    }

    ::v-deep .el-pagination {
        .el-pager {
            .active {
                background: $themeColor !important;
            }

            .number {
                &:hover {
                    background-color: $themeColor !important;
                    color: #fff !important;
                }
            }
        }
    }
}
</style>
